import Checkbox from "components/checkbox";
import { Chevron } from "components/icons/icn-chevron.icon";
import SuggestionContext from "components/suggestion-context";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { isFeatureEnabled } from "utils/feature-flags";
import { Alert, AlertContent, ButtonUnset } from "./styled";
import StyledSuggestionsListHeader from "./suggestions-list-header.styled";

const FEATURE_GENERATE_SUGGESTIONS_EXTERNAL_WAREHOUSE_PRIORITIZATION =
  "FeatureGenerateSuggestions_ExternalWarehousePrioritization";

function renderExpandButton(expandAllItems, itemsExpanded, hasIcon, highlighted) {
  if (!hasIcon) return null;

  return (
    <ButtonUnset
      onClick={(event) => expandAllItems(event.target)}
      style={{ background: "transparent" }}
    >
      <Chevron
        data-testid="expandAllItems-span"
        style={{
          transform: itemsExpanded ? "rotate(180deg)" : "rotate(0deg)",
          background: "transparent",
          color: highlighted ? "#00357A" : "#0E0E0E",
        }}
      />
    </ButtonUnset>
  );
}

function renderBtn(suggestionId, hasSnapshot) {
  if (!suggestionId) return null;
  return <SuggestionContext suggestionId={suggestionId} hasSnapshot={hasSnapshot} />;
}

const SuggestionsListHeader = ({
  children,
  checked,
  checkItem,
  enableCheck,
  expandAllItems,
  itemsExpanded,
  idCheckbox,
  hasIcon,
  isItem,
  isOrder,
  highlighted,
  itemDimmed,
  alertLoadComposition,
  hideMargin,
  suggestionId,
  hasSnapshot,
}) => {
  const [isExternalWarehousePrioritizationEnabled, setIsExternalWarehousePrioritizationEnabled] =
    useState(false);

  useEffect(() => {
    const loadFeatureFlag = async () => {
      try {
        const enabled = await isFeatureEnabled(
          FEATURE_GENERATE_SUGGESTIONS_EXTERNAL_WAREHOUSE_PRIORITIZATION
        );

        setIsExternalWarehousePrioritizationEnabled(enabled);
      } catch {
        setIsExternalWarehousePrioritizationEnabled(false);
      }
    };

    loadFeatureFlag();
  }, []);

  return (
    <StyledSuggestionsListHeader
      className={`suggestion-list-header ${isItem ? "isItem" : ""} ${highlighted ? "item-highlighted" : ""} ${itemDimmed ? "item-dimmed" : ""}`}
    >
      {!isOrder && (
        <Checkbox
          name={`checkbox-${idCheckbox}`}
          checked={checked}
          onChange={checkItem}
          disabled={enableCheck}
        />
      )}
      {isOrder && alertLoadComposition ? (
        <Alert>
          <AlertContent title={intl.get("stocks.suggestionsListItem.alertMessage")}>!</AlertContent>
        </Alert>
      ) : (
        !hideMargin && <span style={{ width: "29px" }}></span>
      )}
      <div className="header-item header-actions">
        {renderExpandButton(expandAllItems, itemsExpanded, hasIcon, highlighted)}
      </div>
      {children}
      {isExternalWarehousePrioritizationEnabled && (
        <div className="header-item header-actions">{renderBtn(suggestionId, hasSnapshot)}</div>
      )}
    </StyledSuggestionsListHeader>
  );
};

SuggestionsListHeader.propTypes = {
  isItem: PropTypes.bool,
  hasIcon: PropTypes.bool,
  idCheckbox: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checked: PropTypes.bool,
  enableCheck: PropTypes.bool,
  itemsExpanded: PropTypes.bool,
  isOrder: PropTypes.bool,
  highlighted: PropTypes.bool,
  itemDimmed: PropTypes.bool,
  checkItem: PropTypes.func,
  expandAllItems: PropTypes.func,
  children: PropTypes.any,
  alertLoadComposition: PropTypes.bool,
  hideMargin: PropTypes.bool,
  suggestionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hasSnapshot: PropTypes.bool,
};

export default SuggestionsListHeader;
